import { ActionReducerMap } from '@ngrx/store';

import { configureCleanReducer, configureSyncReducer, TileAction, TileId } from '@contact/upgrade';

/**
 * Name store feature
 */
export const featureName = 'wallboard';

/**
 * Wallboard state interface
 */
export interface WallboardState {}

/**
 * Initial Wallboard state
 */
export const initialState: WallboardState = {};

/**
 * Wallboard reducers map
 */
export const reducers: ActionReducerMap<WallboardState> = {};

const cleanReducer = configureCleanReducer(featureName, {
  initialState,
  keys: [],
  cleanPredicate: action => action.type === TileAction.Reset.type && action.tileId === TileId.WALLBOARD_CUSTOM,
});
const syncReducer = configureSyncReducer(featureName, []);

/**
 * Core meta reducers array
 */
export const metaReducers = [cleanReducer, syncReducer];
